import { useState } from 'react';
import { CredentialResponse } from '@react-oauth/google';

import { PLATFORM, SOCIAL } from 'src/constants/app';
import { useAppDispatch } from 'src/store';
import { socialLogin } from 'src/thunks/auth';
import notification from 'src/store/ui/notification';

const useLogin = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const googleLoginSuccess = async (res: CredentialResponse) => {
    setLoading(true);
    const { credential } = res;
    if (!credential) return;

    await dispatch(
      socialLogin({
        token: credential,
        platform: PLATFORM.JENO,
        provider: SOCIAL.GOOGLE,
      }),
    );
    setLoading(false);
  };

  const googleLoginError = () => {
    dispatch(notification.on({ type: 'error', message: 'An error occurred!' }));
  };

  return { loading, googleLoginSuccess, googleLoginError };
};

export default useLogin;
